import { Btn, H3, H4, LI, P, UL } from "../../../../AbstractElements";
import { ProductDetails, ProductSizeArray } from "../../../../Constant";
import { useAppSelector } from "../../../../Redux-Toolkit/Hooks";
import { ModalProductDetailsProp } from "../../../../Type/EcommerceType";

export const ModalProductDetails = ({ singleProduct }: ModalProductDetailsProp) => {
const {symbol} = useAppSelector((state)=>state.product)
  return (
    <>
      <H4>{singleProduct.category}</H4>
      <div className="product-price fs-4 mb-1">
        {symbol}{singleProduct.price}
        <del className="f-w-700 fs-5 ms-1">{symbol}{singleProduct.discountPrice}</del>
      </div>
      <div className="product-view product-details-border">
        <H3 className="f-w-600">{ProductDetails}</H3>
        <P className="mb-0">{singleProduct.discription}</P>
      </div>
      <div className="product-size mt-3 mb-2">
        <UL className="simple-list diflex flex-row">
          {ProductSizeArray.map((items, i) => (
            <LI key={i} className="me-2">
              <Btn outline color="light">
                {items}
              </Btn>
            </LI>
          ))}
        </UL>
      </div>
    </>
  );
};
